export const environment = {
  production: true,
  
  apiUrl: "https://umyohighschool.site/api_umyocards/public/api/"
};


